<template>
	<div id="content_body">
		<header-layout :pageHeaderStyle="pageHeaderStyle" :pageHeaderBg="pageHeaderBg" :pageHeaderSpacing="pageHeaderSpacing" :pageHeaderContainer="pageHeaderContainer" :pageTitle="pageTitle" :pageSubtitle="pageSubtitle" :pageIcon="pageIcon"></header-layout>
		<div class="container mt-n15">
			<!-- invoice -->
			<div class="card">
				<div class="card-header">
					<b-form ref="instanceForm" id="instanceForm" autocomplete="off" >
						<!-- Flash -->
						<div v-if="$store.getters.flash.msg" class="alert alert-danger" role="alert" v-html="$store.getters.flash.msg" />
						<div class="form-row">
							<div class="col-md-4">
								<label>
									{{ $t(instanceClassAttr.instanceClass+'.mat')}}
								</label>
								<input type="text" v-model="instance.mat" class="form-control" :class="{'is-invalid': v$.instance.mat.$error, 'is-valid': (!v$.instance.mat.$error && v$.instance.mat.$dirty) }" disabled/>
								<span class="small text-muted d-none d-md-block" v-if="v$.instance.mat.$error">
									{{ v$.instance.mat.$errors[0].$message }}
								</span>
							</div>
							<div class="col-md-4">
								<div class="form-group">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.prsType')}}
									</label>
									<select v-model="prsTypeSelected" class="form-control" :class="{'is-invalid': v$.instance.prsType.$error, 'is-valid': (!v$.instance.prsType.$error && v$.instance.prsType.$dirty) }" :disabled="typeView != 'new'">
										<option v-for="prsType in prsTypeList" :value="prsType.id" :key="prsType.id">
										{{ prsType.typeName}}
										</option>
									</select>
									<span class="small text-muted d-none d-md-block" v-if="v$.instance.prsType.$error">
										{{ v$.instance.prsType.$errors[0].$message }}
									</span>										
								</div>
							</div>
							<div class="col-md-4">
								<div class="form-group">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.prsStore')}}
									</label>
									<!-- :class="{'is-invalid': v$.instance.prsStore.$error, 'is-valid': (!v$.instance.prsStore.$error && v$.instance.prsStore.$dirty) }" -->
									<select v-model="prsStoreSelected" class="form-control" :disabled="typeView != 'new'">
										<option v-for="prsStore in prsStoreList" :value="prsStore.id" :key="prsStore.id">
										{{ prsStore.storeName}}
										</option>
									</select>
									<span class="small text-muted d-none d-md-block" v-if=" v$.instance.prsStore && v$.instance.prsStore.$error">
										{{ v$.instance.prsStore.$errors[0].$message }}
									</span>							
								</div>
							</div>
							
							<div class="col-md-4">
								<label>
									{{ $t(instanceClassAttr.instanceClass+'.typeCivility')}}
								</label>
								<select v-model="typeCivilitySelected" class="form-control" :class="{'is-invalid': v$.instance.typeCivility.$error, 'is-valid': (!v$.instance.typeCivility.$error && v$.instance.typeCivility.$dirty) }" :disabled="typeView=='show'">
									<option v-for="typeCivility in typeCivilityList" :value="typeCivility.id" :key="typeCivility.id">
										{{typeCivility.label}}
									</option>
								</select>	
								<span class="small text-muted d-none d-md-block" v-if="v$.instance.typeCivility.$error">
									{{ v$.instance.typeCivility.$errors[0].$message }}
								</span>
							</div>
							<div class="col-md-4">
								<label>
									{{ $t(instanceClassAttr.instanceClass+'.lastName')}}
								</label>
								<input type="text" v-model="instance.lastName" class="form-control" :disabled="typeView=='show'" :class="{'is-invalid': v$.instance.lastName.$error, 'is-valid': (!v$.instance.lastName.$error && v$.instance.lastName.$dirty) }"/>
								<span class="small text-muted d-none d-md-block" v-if="v$.instance.lastName.$error">
									{{ v$.instance.lastName.$errors[0].$message }}
								</span>
							</div>
							<div class="col-md-4">
								<label>
									{{ $t(instanceClassAttr.instanceClass+'.firstName')}}
								</label>
								<input type="text" v-model="instance.firstName" class="form-control" :class="{'is-invalid': v$.instance.firstName.$error, 'is-valid': (!v$.instance.firstName.$error && v$.instance.firstName.$dirty) }" :disabled="typeView=='show'"/>
								<span class="small text-muted d-none d-md-block" v-if="v$.instance.firstName.$error">
									{{ v$.instance.firstName.$errors[0].$message }}
								</span>
							</div>
							<div v-show="prsTypeSelected == 1" class="col-md-4">
								<label>
									{{ $t(instanceClassAttr.instanceClass+'.dateBirth')}}
								</label>
								<!-- :class="{'is-invalid': v$.instance.dateBirth.$error, 'is-valid': (!v$.instance.dateBirth.$error && v$.instance.dateBirth.$dirty) }" -->
								<input v-if="prsTypeSelected == 1" type="date" v-model="instance.dateBirth" class="form-control" :disabled="typeView=='show'"/>
								<span class="small text-muted d-none d-md-block" v-if="v$.instance.dateBirth && v$.instance.dateBirth.$error">
									{{ v$.instance.dateBirth.$errors[0].$message }}
								</span>
							</div>
							<div v-show="prsTypeSelected == 1" class="col-md-4">
								<label>
									{{ $t(instanceClassAttr.instanceClass+'.placeBirth')}}
								</label>
								<!-- :class="{'is-invalid': v$.instance.placeBirth.$error, 'is-valid': (!v$.instance.placeBirth.$error && v$.instance.placeBirth.$dirty) }" -->
								<input v-if="prsTypeSelected == 1" type="text" v-model="instance.placeBirth" class="form-control" :disabled="typeView=='show'"/>
								<span class="small text-muted d-none d-md-block" v-if="v$.instance.placeBirth && v$.instance.placeBirth.$error">
									{{ v$.instance.placeBirth.$errors[0].$message }}
								</span>
							</div>
							<div class="col-md-4">
								<label>
									{{ $t(instanceClassAttr.instanceClass+'.address')}}
								</label>
								<input type="text" v-model="instance.address" class="form-control" :class="{'is-invalid': v$.instance.address.$error, 'is-valid': (!v$.instance.address.$error && v$.instance.address.$dirty) }" :disabled="typeView=='show'"/>
								<span class="small text-muted d-none d-md-block" v-if="v$.instance.address.$error">
									{{ v$.instance.address.$errors[0].$message }}
								</span>
							</div>
							<div class="col-md-4">
								<label>
									{{ $t(instanceClassAttr.instanceClass+'.phoneAddress')}}
								</label>
								<input type="text" v-model="instance.phoneAddress" class="form-control" :class="{'is-invalid': v$.instance.phoneAddress.$error, 'is-valid': (!v$.instance.phoneAddress.$error && v$.instance.phoneAddress.$dirty) }" :disabled="typeView=='show'"/>
								<span class="small text-muted d-none d-md-block" v-if="v$.instance.phoneAddress.$error">
									{{ v$.instance.phoneAddress.$errors[0].$message }}
								</span>
							</div>
							<div v-show="prsTypeSelected == 1" class="col-md-4">
								<label>
									{{ $t(instanceClassAttr.instanceClass+'.posteAddress')}}
								</label>
								<input type="text" v-model="instance.posteAddress" class="form-control" :disabled="typeView=='show'"/>
							</div>
							<div class="col-md-4">
								<label>
									{{ $t(instanceClassAttr.instanceClass+'.internetAddress')}}
								</label>
								<input type="text" v-model="instance.internetAddress" class="form-control" :disabled="typeView=='show'"/>
							</div>

							<!-- EMPLOYÉ -->
							<div v-if="prsTypeSelected == 1" class="col-md-4">
								<div class="form-group">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.prsFunction')}}
									</label>
									<!-- :class="{'is-invalid': v$.instance.prsFunction.$error, 'is-valid': (!v$.instance.prsFunction.$error && v$.instance.prsFunction.$dirty) }" -->
									<select v-model="prsFunctionSelected" class="form-control" :disabled="typeView=='show'">
										<option v-for="prsFunction in prsFunctionList" :value="prsFunction.id" :key="prsFunction.id">
											{{prsFunction.functionName}}
										</option>
									</select>
									<span class="small text-muted d-none d-md-block" v-if=" v$.instance.prsFunction && v$.instance.prsFunction.$error">
										{{ v$.instance.prsFunction.$errors[0].$message }}
									</span>							
								</div>
							</div>
							<div v-if="prsTypeSelected == 1" class="col-md-4">
								<div class="form-group">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.prsService')}}
									</label>
									<!-- :class="{'is-invalid': v$.instance.prsService?v$.instance.prsService.$error: false, 'is-valid': (!v$.instance.prsService.$error && v$.instance.prsService.$dirty) }" -->
									<select v-model="prsServiceSelected" class="form-control" :disabled="typeView=='show'">
										<option v-for="prsService in prsServiceList" :value="prsService.id" :key="prsService.id">
											{{prsService.serviceName}}
										</option>
									</select>
									<span class="small text-muted d-none d-md-block" v-if="v$.instance.prsService && v$.instance.prsService.$error">
										{{ v$.instance.prsService.$errors[0].$message }}
									</span>								
								</div>
							</div>
							<div v-show="prsTypeSelected == 1" class="col-md-4">
								<label>
									{{ $t(instanceClassAttr.instanceClass+'.pay')}}
								</label>
								<!-- :class="{'is-invalid': v$.instance.pay.$error, 'is-valid': (!v$.instance.pay.$error && v$.instance.pay.$dirty) }" -->
								<input v-if="prsTypeSelected == 1" type="number" step="any" v-model="instance.pay" class="form-control" :disabled="typeView=='show'" @input="amountToLetter($event, 'pay')" @change="amountLetter = {}"/>
								<span v-if="amountLetter && amountLetter.pay != '' " class="amount-letter">
									{{amountLetter.pay}}
								</span>
								<span class="small text-muted d-none d-md-block" v-if="v$.instance.pay && v$.instance.pay.$error">
									{{ v$.instance.pay.$errors[0].$message }}
								</span>
							</div>
							<div class="col-md-4">
								<label>
									{{ $t(instanceClassAttr.instanceClass+'.dateEntry')}}
								</label>
								<input type="date" v-model="instance.dateEntry" class="form-control" :class="{'is-invalid': v$.instance.dateEntry.$error, 'is-valid': (!v$.instance.dateEntry.$error && v$.instance.dateEntry.$dirty) }" :disabled="typeView=='show'"/>
								<span class="small text-muted d-none d-md-block" v-if="v$.instance.dateEntry.$error">
									{{ v$.instance.dateEntry.$errors[0].$message }}
								</span>
							</div>
						</div>
						
					</b-form>
					
				</div>
				<div class="card-body p-4 p-md-5" v-if="typeView == 'show' && prsTypeSelected == 1">
					<div class="table-responsive">
						<table id="instanceTable" class="table table-sm table-striped table-bordered table-hover mb-0">
							
							<thead class="border-bottom thead-light">
								<tr class="small text-uppercase text-muted">
									<th scope="col" width="80%">
										{{ $t(instanceClassAttr.instanceClass+'.prsTeam')}}
									</th>
									<th scope="col" width="20%" class="align-center">
										{{ $t('default.actions')}}
									</th>
								</tr>
							</thead>
							<tbody>
								<tr class="border-bottom" v-for="prsTeam in prsTeamList" :key="prsTeam.id">
									<td>
										<div class="font-weight-bold">
											{{prsTeam.lib}}
										</div>
									</td>
									<td class="align-center">
										<div class="">
											<!-- X
											{{prsTeam.prsMembersIds.includes(instance.id)}}
											{{prsTeam.prsMembersIds}} -->
											<button class="btn btn-icon btn-danger" v-if="prsTeam.prsMembersIds.includes(instance.id)" @click="addRemoveMember(prsTeam, 'remove')">
												<fa icon="minus"/>
											</button>
											<button class="btn btn-icon btn-success" v-else @click="addRemoveMember(prsTeam, 'add')">
												<fa icon="add"/>
											</button>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					
				</div>
				
				<div class="card-footer" v-if="$store.getters.isAuthorized(['ROLE_ADMIN', 'ROLE_MANAGER'])">
					<div align="center">
						<b-button v-if="typeView != 'show'" class="btn btn-success" 
							@click="handleSubmit()" >
							<span v-if="typeView == 'new'">
								<fa icon="check"/>
								{{ $t("default.button.create")}}
							</span>
							<span v-if="typeView == 'edit'">
								<fa icon="check"/>
								{{ $t("default.button.update")}}
							</span>
						</b-button>
						&ensp;
						<b-button v-if="typeView == 'edit'" class="btn btn-dark" @click="typeView = 'show'" >
							<span>
								<fa icon="times"/>
								{{ $t("default.button.cancel")}}
							</span>
						</b-button>
						
						<b-button v-if="typeView == 'show' " class="btn btn-primary" 
							@click="typeView = 'edit'" >
							<span>
								<fa icon="edit"/>
								{{ $t("default.button.edit")}}
							</span>
						</b-button>
						&ensp;
						
						<b-button v-if="typeView == 'show' && !instance.active" class="btn btn-success" 
							@click="instance.typeChange = 'enable'; axiosValid()">
							<span>
								<fa icon="check"/>
								{{ $t("prsperson.button.active")}}
							</span>
						</b-button>
						<b-button v-if="typeView == 'show' && instance.active" class="btn btn-danger" 
							@click="instance.typeChange = 'disable'; axiosValid()">
							<span>
								<fa icon="times"/>
								{{ $t("prsperson.button.disable")}}
							</span>
						</b-button>


					</div>
				</div>
				
			</div>
		</div>
	</div>

</template>
<script>
	import Header from '@/layouts/templates/Header.vue';
	// import AutoSearch from '@/components/templates/AutoSearch.vue';
	
	import { useVuelidate } from '@vuelidate/core'
	import { required, email,minLength, maxLength } from '@vuelidate/validators'

	export default {
		name: 'prsPerson',
		props: {
			type: {
				type: Number,
				default: NaN,
				required: false
			},
			itemId: {
				type: Number,
				default: NaN,
				required: false
			}
		},
		
		setup () { return { v$: useVuelidate() }},
		components: {
			'header-layout': Header,
			// 'auto-search': AutoSearch,
		},
		
		data() {
			return {
				pageHeaderStyle: process.env.VUE_APP_PAGE_HEADER_STYLE,
				pageHeaderBg: process.env.VUE_APP_PAGE_HEADER_BG,
				pageHeaderSpacing: 'pb-10',
				pageHeaderContainer: 'container',
				pageSubtitle: this.$t('prsperson.label'),
				pageTitle: this.$t('prsperson.show'),
				pageIcon: 'user-plus',
				instanceClassAttr: {
					instanceClass: 'prsperson'
				},

				instance: {
					prsType:'',
					mat: 'AUTO',
					typeCivility: '',
					firstName: '',
					lastName: '',

					// dateBirth: null,
					placeBirth: '',
					address: '',

					phoneAddress: '',
					posteAddress: '',
					internetAddress: '',

					prsStore: '',
					prsFunction: '',
					prsService: '',
					
					pay: '',
					active: true,
					dateEntry: new Date ().toISOString().split('T')[0],
				},
				vueRules: {},
				prsTypeSelected: '',
				prsStoreSelected: '',
				typeCivilitySelected: '',
				prsFunctionSelected: '',
				prsServiceSelected: '',
				prsTypeList: [],
				prsFunctionList: [],
				prsServiceList: [],
				prsStoreList: [],
				typeCivilityList:[
					{id:'M.', label:'Monsieur'},
					{id:'Mme', label:'Madame'},
					{id:'Mlle', label:'Mademoiselle'},
					{id:'Sté', label:'Société'}
				],
				prsTeamList: [],
				amountLetter: {},
				typeView: 'new', // new, show, edit
				
			}
		},
		validations () {
			return this.vueRules
		},
		async created (){
			this.vueRules = this.createVeerules()
		},
		async mounted () {
			this.pageTitle = this.$t('prsperson.'+this.typeView)
			this.$store.dispatch('initFlash');
			
			if(this.$store.getters.loggedIn) {
				// GET LIST prstype
				await this.$store.dispatch('axiosGet', {
					domain: 'prstype'
				})
				.then(response => {
					this.prsTypeList = response.data
				})
				.catch(error => {
					console.log('error catch prstype == ', error.message)
				})

				// GET LIST prsfunction
				await this.$store.dispatch('axiosGet', {
					domain: 'prsfunction'
				})
				.then(response => {
					this.prsFunctionList = response.data
				})
				.catch(error => {
					console.log('error catch prsFunctionList == ', error.message)
				})

				// GET LIST prsServiceList
				await this.$store.dispatch('axiosGet', {
					domain: 'prsservice'
				})
				.then(response => {
					this.prsServiceList = response.data
				})
				.catch(error => {
					console.log('error catch prsServiceList == ', error.message)
				})
				
				// GET LIST prsstore
				await this.$store.dispatch('axiosGet', {
					domain: 'prsstore'
				})
				.then(response => {
					this.prsStoreList = response.data
				})
				.catch(error => {
					console.log('error catch prsStoreList == ', error.message)
				})

				// GET LIST prsteam
				await this.$store.dispatch('axiosGet', {
					domain: 'prsteam'
				})
				.then(response => {
					this.prsTeamList = response.data
				})
				.catch(error => {
					console.log('error catch prsTeamList == ', error.message)
				})

				if(this.itemId && !isNaN(this.itemId)){
					await this.$store.dispatch('axiosGet', {
						domain: 'prsperson',
						id: this.itemId
					})
					.then(response => {
						this.typeView = 'show'
						if(response.data){
							this.instance = response.data
							if(this.instance.dateBirth)
								this.instance.dateBirth = this.$moment(this.instance.dateBirth).format('YYYY-MM-DD').toString()
							this.instance.dateEntry = this.$moment(this.instance.dateEntry).format('YYYY-MM-DD').toString()

							this.prsTypeSelected = this.instance.prsType?this.instance.prsType.id : ''
							// this.type = this.prsTypeSelected

							this.prsStoreSelected = this.instance.prsStore?this.instance.prsStore.id : ''
							this.typeCivilitySelected = this.instance.typeCivility
							if(this.instance.prsFunction)
								this.prsFunctionSelected = this.instance.prsFunction?this.instance.prsFunction.id : ''
							if(this.instance.prsService)
								this.prsServiceSelected = this.instance.prsService?this.instance.prsService.id : ''
						}
					})
					.catch(error => {
						console.log('error catch prsperson == ', error.message)
					})
				}
				if(this.type && !isNaN(this.type)){
					this.prsTypeSelected = this.type
					this.instance.prsType = [this.type]
					this.prsTypeList = this.prsTypeList.filter(item => item.id == this.type)
				}
			}
		},
		methods: {
			createVeerules(){
				let rules = {
					instance: {
						mat: { required },
						// prsStore: { required },
						prsType: { required },
						typeCivility: { required },
						firstName: { required },
						lastName: { required },

						address: { required },
						phoneAddress: { required },
						dateEntry: { required },

						// prsFunction: { required },
						// prsService: { required },
					}
				}
				return rules
			},
			async amountToLetter(e, attrName) {
				if(e.target.value && e.target.value.length > 2 && attrName && attrName != ''){
					await this.$store.dispatch('axiosGet', { url: '/api/sequence/convert?amount='+e.target.value
					})
					.then(response => {
						if(response.data && response.data.results)
							this.amountLetter[attrName] = response.data.results
					}).catch(error => {
						console.log('error catch convert amount == ', error.message)
					})
				}
			},
			
			async handleSubmit() {
				this.instance.prsStore = this.prsStoreSelected
				this.instance.prsType = this.prsTypeSelected
				this.instance.typeCivility = this.typeCivilitySelected
				this.instance.prsFunction = this.prsFunctionSelected
				this.instance.prsService = this.prsServiceSelected

				let result = await this.v$.$validate()
				let errors = ''
				
				if(this.prsTypeSelected == 1 || this.prsTypeSelected == 2 || this.prsTypeSelected == 4 ){
					if(!this.instance.prsStore)
						errors = errors + "<li> <a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>Veuiller renseigner le store</li>"
					if(this.prsTypeSelected == 1){
						if(!this.instance.dateBirth)
							errors = errors + "<li> <a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>Veuiller renseigner la date de naissance</li>"
						if(!this.instance.placeBirth)
							errors = errors + "<li> <a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>Veuiller renseigner le lieu de naissance</li>"
						if(!this.instance.prsFunction)
							errors = errors + "<li> <a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>Veuiller renseigner la fonction</li>"
						if(!this.instance.prsService)
							errors = errors + "<li> <a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>Veuiller renseigner le service</li>"
						if(!this.instance.pay)
							errors = errors + "<li> <a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>Veuiller renseigner le salaire</li>"
					}
				}
				if(errors != ''){
					this.$store.getters.getErrorMsgFormatted(errors);
					result = false
					return
				}
				

				if (!result)
					return
				else{
					this.$store.dispatch('initFlash');
					this.$store.dispatch('loading')
					this.axiosPost()
				}
			},
			async axiosPost() {
				try {
					if(this.itemId && !isNaN(this.itemId)){
						await this.$store.dispatch('axiosPut', {
							domain: 'prsperson',
							data: this.instance,
							id:this.itemId
						})
						.then(res => {
							// console.log('res update === ', res)
							this.$nextTick(() => {
								let msg = this.$t("prsperson.label") + " "+this.itemId;
								
								if(res.data && res.data.error){
									msg = msg+ ' '+ res.data.error;
									this.$store.dispatch('showToast', {
										type: 'warning', message: msg
									});
									this.typeView = 'show'
									this.$router.push('/prsperson/show/'+this.itemId)
								}
								else{
									this.$store.dispatch('showToast', {
										type: 'success', message: this.$t('toast.updated.message', { obj: msg})
									});
									this.$router.go(0)
								}
								// this.typeView = 'show'
								// this.$router.push('/prsperson/show/'+this.itemId)
								this.$store.dispatch('unloading')
							});
						})
						.catch(error => {
							console.log('error update === ', error)
							this.$store.getters.getErrorMsgFormatted(error);
							this.$store.dispatch('unloading')
						})
					}
					else {
						await this.$store.dispatch('axiosPost', {
							domain: 'prsperson',
							data: this.instance //data
						})
						.then(res => {
							this.$nextTick(() => {
								let msg = this.$t("prsperson.label") + " "+res.data.id;
								this.$store.dispatch('showToast', {
									type: 'success', message: this.$t('toast.created.message', { obj: msg})
								});
								this.$router.push('/prsperson/show/'+res.data.id)
								this.$store.dispatch('unloading')
							});
						})
						.catch(error => {
							// console.log('Error', error.response)
							this.$store.getters.getErrorMsgFormatted(error);
							this.$store.dispatch('unloading')
						})
					}
					
				}
				catch (e) {
					console.log('Error ', e)
				}

			},

			async axiosValid() { //this.instance.typeChange
				console.log('this.instance.typeChange = ', this.instance.typeChange)
				try {
					if(this.itemId && !isNaN(this.itemId)){
						await this.$store.dispatch('axiosPut', {
							domain: 'prsperson/changestatus',
							data: this.instance,
							id:this.itemId
						})
						.then(res => {
							// console.log('res axiosValid === ', res)
							this.$nextTick(() => {
								let msg = this.$t("prsperson.label") + " "+this.itemId;
								if(res.data && res.data.error){
									msg = msg+ ' '+ res.data.error;
									this.$store.dispatch('showToast', {
										type: 'warning', message: msg
									});
									this.$router.push('/prsperson/show/'+this.itemId)
								}
								else{
									this.$store.dispatch('showToast', {
										type: 'success', message: this.$t('toast.received.message', { obj: msg})
									});
									this.$router.go(0)
								}
								// this.$router.go(0)
								// this.$router.push('/prsperson/show/'+this.itemId)
								this.$store.dispatch('unloading')
							});
						})
						.catch(error => {
							console.log('error axiosValid === ', error)
							this.$store.getters.getErrorMsgFormatted(error);
							this.$store.dispatch('unloading')
						})
					}
					
					
				}
				catch (e) {
					console.log('Error ', e)
				}

			},

			async addRemoveMember(prsTeam, type) {
				if(type === 'add')
					prsTeam.prsMembers.push(this.instance)
				else if(type === 'remove')
					prsTeam.prsMembers = prsTeam.prsMembers.filter(item => item.id != this.instance.id)

				try {
					if(this.itemId && !isNaN(this.itemId)){
						await this.$store.dispatch('axiosPut', {
							domain: 'prsteam',
							data: prsTeam,
							id: prsTeam.id
						})
						.then(res => {
							this.$nextTick(() => {
								let msg = this.$t("prsteam.label") + " "+prsTeam.lib;
								if(res.data && res.data.error){
									msg = msg+ ' '+ res.data.error;
									this.$store.dispatch('showToast', {
										type: 'warning', message: msg
									});
									this.$router.push('/prsperson/show/'+this.itemId)
								}
								else{
									this.$store.dispatch('showToast', {
										type: 'success', message: this.$t('toast.updated.message', { obj: msg})
									});
									// this.$router.push('/prsperson/show/'+this.itemId)
									this.$router.go(0)
								}
								
								this.$store.dispatch('unloading')
							});
						})
						.catch(error => {
							console.log('error addRemoveMember === ', error)
							this.$store.getters.getErrorMsgFormatted(error);
							this.$store.dispatch('unloading')
						})
					}
					
					
				}
				catch (e) {
					console.log('Error ', e)
				}

			},
		}
		
	}

</script>